import { render } from "./JenisTarifPage.vue?vue&type=template&id=67d21f7f&scoped=true"
import script from "./JenisTarifPage.vue?vue&type=script&lang=js"
export * from "./JenisTarifPage.vue?vue&type=script&lang=js"

import "./JenisTarifPage.vue?vue&type=style&index=0&id=67d21f7f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d21f7f"]])

export default __exports__